/* eslint-disable react/prop-types */
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTablePagination from "examples/Tables/DataTable/DataTablePagination";
import { useAxiosPrivate } from "hooks/useAxiosPrivate";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LeadDetailsModal from "../activity/LeadDetailsModal";
import MDBadge from "components/MDBadge";
import dayjs from "dayjs";
import { Icon } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import LeadActivites from "./LeadActivites";
const index = () => {
  const handleReset = () => {};
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [searchParams] = useSearchParams();
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const handleSelect = (status) => {
    setSelectedStatus(status);
    handleReset(status); // optional: call API/filter
  };
  const navigate = useNavigate();
  const [leadsData, setLeadsData] = useState([]);
  useEffect(() => {
    setSelectedStatus(searchParams.get("status"));
    getLeadsData(0, searchParams.get("status"), searchParams.get("employeeId"));
  }, []);

  const handleTabChange = (status) => {
    // console.log(status);
    handleSelect(status);
    searchParams.set("status", status);
    getLeadsData(0, status, searchParams.get("employeeId"));
  };

  const getLeadsData = (pageNo, leadState, id) => {
    const params = {
      page: pageNo,
      size: pageSize,
      state: leadState === "All" || leadState === "Marketing" ? "" : leadState,
      id: id,
    };
    if (leadState === "Marketing") {
      params.source = "Marketing";
    } else {
      params.source = "";
    }
    let urlParams = "";
    if (params) {
      Object.keys(params).forEach(function (key, index) {
        urlParams += (index === 0 ? "?" : "&") + key + "=" + params[key];
      });
    }
    let url;
    if (id == null) {
      url = `om/list-all-leads${urlParams}`;
    } else {
      url = `om/list-leads-for-teams${urlParams}`;
    }
    let options = {
      method: "GET",
      url,
    };
    setLoading(true);
    axiosPrivate(options)
      .then((response) => {
        // console.log(response?.data?.data?.content);
        setLeadsData(response?.data?.data?.content);
        setTotalCount(response?.data?.data?.totalElements);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const [selectedLead, setSelectedLead] = useState(null);
  const [open, setOpen] = useState(false);

  const openDetailsModal = (lead) => {
    setSelectedLead(lead);
    setOpen(true);
  };

  const columns = useMemo(
    () => [
      { Header: "Name", accessor: "name" },
      { Header: "Status", accessor: "leadState" },
      { Header: "Created On", accessor: "createdOn" },
      { Header: "Assigned to", accessor: "assignedTo" },
      { Header: "Source", accessor: "leadSource" },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  const leadColors = {
    Cold: "#F7A829",
    Warm: "#2EBDC5",
    Hot: "#28e175ff",
    Onhold: "#95a5a6",
    Win: "#087b1dff",
    Fresh: "#3378edff",
    Marketing: "#f38131ff",
  };

  const getRows = (apiData) => {
    return apiData.map((item) => ({
      name: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.name}
        </MDTypography>
      ),

      leadState: (
        <MDTypography
          variant="caption"
          fontWeight="medium"
          sx={{
            backgroundColor: leadColors[item?.leadState] || "#9e9e9e",
            color: "#fff",
            px: 1.2,
            py: 0.4,
            borderRadius: "8px",
            display: "inline-block",
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: 1.2,
          }}
        >
          {item?.leadState}
        </MDTypography>
      ),

      createdOn: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.assignedOn ? dayjs.unix(item.assignedOn).format("DD MMM YYYY") : ""}
        </MDTypography>
      ),

      assignedTo: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.assignedTo}
        </MDTypography>
      ),

      leadSource: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.leadSource}
        </MDTypography>
      ),

      action: (
        <>
          <Tooltip title={"View Details"} arrow>
            <MDTypography
              component="a"
              href="#"
              color="text"
              onClick={() => openLeadDetails(item?.id)}
              //   onClick={() => openDetailsModal(item)}
            >
              <Icon>visibility</Icon>
            </MDTypography>
          </Tooltip>
          <></>
          <MDTypography component="a" href="#" color="text" onClick={() => openAllTasks(item)}>
            <Icon>assignment</Icon>
          </MDTypography>
          {item?.ocfId && (
            <Tooltip title={"OTF FORM"} arrow>
              <MDTypography
                component="a"
                href="#"
                color="text"
                onClick={() => {
                  navigate(`/otf-form/${item?.ocfId}`);
                }}
              >
                <Icon>link</Icon>
              </MDTypography>
            </Tooltip>
          )}
          {/* <MDButton size="small" color="info" onClick={() => openDetailsModal(item)}>
            Call History
          </MDButton>
          <MDButton size="small" color="info" onClick={() => openDetailsModal(item)}>
            Activities
          </MDButton> */}
        </>
      ),
    }));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [openAllTasksModal, setOpenAllTasksModal] = useState(false);
  const [selectedTaskLead, setSelectedTaskLead] = useState(null);
  const openAllTasks = (item) => {
    setSelectedTaskLead(item?.id);
    setOpenAllTasksModal(true);
  };
  const [openLeadModal, setOpenLeadModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const openLeadDetails = (leadId) => {
    setSelectedLeadId(leadId);
    setOpenLeadModal(true);
  };

  return (
    <DashboardLayout loading={loading}>
      <DashboardNavbar />
      <MDBox
        py={0}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <MDBox>
          {searchParams.get("employeeName")
            ? `Selected ${searchParams.get("employeeName")}`
            : "Selected (self)"}
        </MDBox>
        <MDBox display="flex" gap={2} flexWrap="wrap">
          {["Hot", "Cold", "Warm", "Onhold", "Win", "Marketing"].map((status) => (
            <MDButton
              key={status}
              size="small"
              onClick={() => handleTabChange(status)}
              variant={selectedStatus === status ? "contained" : "outlined"}
              color={selectedStatus === status ? "success" : "info"}
            >
              {status}
            </MDButton>
          ))}
        </MDBox>
      </MDBox>

      <Grid item xs={12} py={4}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Leads
            </MDTypography>
            {/* <MDTypography variant="h6" color="white"></MDTypography> */}
          </MDBox>
          <MDBox pt={3}>
            <DataTablePagination
              table={{
                columns,
                rows: getRows(leadsData),
                totalCount,
                pageCount: Math.ceil(totalCount / pageSize),
              }}
              loading={loading}
              page={page}
              pageSize={pageSize}
              onPageChange={(p) => {
                setPage(p);
                getLeadsData(p, searchParams.get("status"), searchParams.get("employeeId"));
              }}
              onPageSizeChange={(s) => {
                console.log(s);
              }}
            />
          </MDBox>
          {/* <LeadDetailsModal open={open} onClose={handleClose} data={selectedLead} /> */}
          <LeadActivites
            open={openAllTasksModal}
            onClose={() => {
              setOpenAllTasksModal(!openAllTasksModal);
            }}
            leadId={selectedTaskLead}
          />
          <LeadDetailsModal
            open={openLeadModal}
            onClose={() => {
              setOpenLeadModal(!openLeadDetails);
            }}
            leadId={selectedLeadId}
          />
        </Card>
      </Grid>
    </DashboardLayout>
  );
};

export default index;
